import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  HostListener,
  ChangeDetectorRef // LUMBA-1308
} from '@angular/core'

import { AppState } from '../app.service'
import { Path } from '../path/path-v2.model'
import { ContentSurvey, ContentSurveyStats } from '../content-survey/content-survey.model'
import { ContentSurveyService } from '../content-survey/content-survey.service'
import { CordovaService } from '../cordova.service'
import { ContentSurveyQuestion } from './content-survey-question.model'
import { ContentSurveyOption } from './content-survey-option.model'
import { WalletService } from '../wallet/wallet.service'
import { SpinnerService } from '../spinner.service'
import mixpanel from 'mixpanel-browser'
import { AlertController, PopoverController } from '@ionic/angular'
import { expandOnEnterAnimation } from 'angular-animations'
import { PopoverComponent } from '../shared/popover/popover.component'
import { HomeUiService } from '../new-design/home-ui.service';
import { I18n } from '../i18n.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations'

@Component({
  selector: 'first90-content-survey',
  templateUrl: './content-survey.component.html',
  animations: [
    expandOnEnterAnimation({ duration: 50 }),
     trigger('animateContent', [
          transition(':enter', [
            query(':scope > *', [
              style({ opacity: 0, transform: 'translateY(8px)' })
            ], { optional: true }),
    
            query(':scope > *', [
              stagger(100, [
                animate(
                  '800ms cubic-bezier(0.76, 0, 0.24, 1)',
                  style({ opacity: 1, transform: 'translateY(0)' })
                )
              ])
            ], { optional: true })
          ]),
    
          transition(':leave', [
            animate(
              '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 0, transform: 'translateY(-75px)' })
            )
          ])
        ])
  ],
  styleUrls: ['./content-survey.component.scss']
})
export class ContentSurveyComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() contentSurvey
  @Input() isPreview: boolean
  @Input() inverted = false
  @Input() progressItems = [];
  @Input() currentIndex = 0;
  @Input() screenId: any;

  enabled = true
  path: Path
  stats: any[] = [];
  status: string
  chart = []
  loading: boolean
  enableFinal: boolean;
  isMobile: boolean;
  statsPer=[];
  optionArray: number[];
  QuesstionIdArray: number[];
  showActionpoints=false;
  showFinalize = false;
  userResponse=[];
  constructor(
    private contentSurveyService: ContentSurveyService,
    private appState: AppState,
    private spinnerService: SpinnerService,
    private cordovaService: CordovaService,
    private popover: PopoverController,
    private walletService: WalletService,
    private alertController: AlertController,
    public homeUIService: HomeUiService,
    private cdRef: ChangeDetectorRef, // LUMBA-1308
    private i18n: I18n
  ) {
    this.path = this.appState.get('currentPath')
    // this.isEnabled()
    this.isMobile = this.appState.get('isMobile')
  }

  ngOnInit() {
    if (this.contentSurvey) {
      if (this.contentSurvey?.screen?.isCompleted) {
        // Restore isSelected from saved userResponse (same pattern as poll-v2)
        this.contentSurvey.screen.content.questions =
          this.contentSurvey.screen.content.questions?.map((question: any) => ({
            ...question,
            options: question.options?.map((opt: any) => ({
              ...opt,
              isSelected: opt.optionId === question.userResponse?.optionId
            }))
          }));
        this.contentSurvey?.screen?.content?.questions?.forEach((question: any) => {
          this.stats.push(question?.stats);
        });
      } else {
        // Active step: restore isSelected from client-side AppState cache,
        // since getStepDetails refetch discards unsaved local selections
        const cached = this.appState.get('contentSurveySelections')?.[this.contentSurvey?.screenContentId] ?? {};
        this.contentSurvey.screen.content.questions =
          this.contentSurvey.screen.content.questions?.map((question: any) => ({
            ...question,
            options: question.options?.map((opt: any) => ({
              ...opt,
              isSelected: cached[question.questionId] != null
                ? opt.optionId === cached[question.questionId]
                : opt.isSelected ?? false
            }))
          }));
        this.storeSurveyData(this.contentSurvey);
      }
      this.appState.set('surveyStats', this.stats)
    }
    this.isMobile = this.appState.get('isMobile')

  }

  ngAfterViewInit() {
    if (this.contentSurvey?.screen?.isCompleted) this.setStats()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['contentSurvey'] || changes['contentSurvey'].firstChange) { return false }
  }

  setStats() {
    if (!this.stats) {
      return
    }
    if (!this.stats?.length) {
      return
    }
    // if (!this.stats['data'].length) {
    //   return
    // }
this.stats?.forEach((stat)=>{
  const total = stat?.data?.reduce((sum, n) => sum + n)
  if(total){
    this.statsPer.push(stat?.data?.map(n => Math.round(n * 100 / total)));

  }
  else {

    this.statsPer.push(stat?.data?.map(n => total))
  }
})

  }

  onAnimationDone(event: any) {
    const element = event.element as HTMLElement;
    let primaryColor;
      
    primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--highlight-color');
    element.style.borderColor = primaryColor ;
  }

  storeSurveyData(contentSurvey){
    let optArray =[];
    let questionArray =[];
    this.userResponse =[];
    contentSurvey?.screen?.content?.questions?.forEach((question)=>{
      question?.options?.forEach((option)=>{
        if (option?.isSelected) {
          optArray.push(option.optionId);
          questionArray.push(question.questionId)
          this.userResponse.push({
            question_id: question.questionId,
            option_id: option.optionId
          });
        }
        else {
          questionArray.push(question.questionId)
          questionArray =[...new Set(questionArray)]
        }
      })
    })
    questionArray =[...new Set(questionArray)]
    this.QuesstionIdArray = [...new Set(questionArray)];
    // this.optionArray = [...new Set(optArray)];
    this.optionArray = optArray;
    if (!this.enableFinal && optArray?.length == questionArray?.length) {
      this.showFinalize = true;
      console.log("this.eableFinal ", this.enableFinal, this.optionArray, questionArray)
      setTimeout(() => {
        this.showFinalize = false;
      }, 600);
    }
    this.enableFinal = optArray?.length ==questionArray?.length;
    
  }
  saveSurvey(contentSurvey) {
    this.storeSurveyData(contentSurvey);
     this.loading = true
  // this.spinnerService.on()
    this.cdRef.detectChanges();
     let input = {
      step_id:this.contentSurvey?.stepId,
      screen_id:this.contentSurvey?.screenId,
      screen_content_id: this.contentSurvey?.screenContentId,
      answers: this.userResponse,
     }
   this.contentSurveyService.saveUserAssessmentAnswers(input).subscribe(response => {
    mixpanel.track("In Steps- assessment screen user response", {'data': response?.data?.answers})
   for(let i=0; i<response?.data?.answers?.length;i++) {
     this.contentSurvey.screen.content.questions[i].userResponse = response?.data?.answers[i]
   }
   this.enableFinal =false; 
    this.showActionpoints=true;
    setTimeout(()=>{
      this.showActionpoints=false;
    },3000);
  //  this.spinnerService.off()
   this.stats =[];
   response?.data?.answers?.forEach((answer)=>{
     this.stats.push(answer?.stats)
   })
      this.contentSurvey.screen.isCompleted = true;
      // Persist into DailyStepsData + currentPath so completion survives an in-step close/reopen
      // (which re-derives step data from currentPath) without a refresh.
      this.appState.persistScreenContent(
        { isCompleted: true },
        { screenContentId: this.contentSurvey?.screenContentId }
      );
      const selections = this.appState.get('contentSurveySelections') ?? {};
      delete selections[this.contentSurvey?.screenContentId];
      this.appState.set('contentSurveySelections', selections);
    // this.appState.get('currentPath').update('contentSurveys', this.contentSurvey.id, {isCompleted: true})       
    // this.appState.updateAcrossSteps(this.appState.get('DailyStepsData'),'contentSurveys', this.contentSurvey?.screen?.id, {isCompleted: true})
      this.cdRef.detectChanges()
    this.setStats();
    this.appState.set('surveyStats', this.stats)
    this.loading = false
    // if(this.isMobile) {
    //   setTimeout(()=>{
    //     this.presentAlert(contentSurvey.question.rationale);
    //   },1300)
    // }
    this.cdRef.detectChanges()
  }, error => {
    // this.spinnerService.off()
    this.contentSurvey?.screen?.content?.questions?.forEach((question)=>{
      question?.options?.forEach((option)=>{
        if(option?.isSelected) {
          option.isSelected =false;
        }
      });
    });    
    this.enableFinal =false; 
    this.loading = false
    this.cdRef.detectChanges() // LUMBA-1308
  })
  }
  onOptionClicked(question, option) {
    if(!this.contentSurvey?.screen?.isCompleted) {
      mixpanel.track('In Steps-clicked option', {'question': question?.text, 'answer': option.text})
      if(this.appState.get('IsOptionSelected') ==undefined) {
        this.appState.set('IsOptionSelected',true);
      }
      question.options.forEach((opt)=>{
        if(opt.optionId ==option.optionId) {
          option.isSelected = true
        }
        else {
          opt.isSelected =false
        }
      })
      // Persist selection so it survives getStepDetails refetch on step close/reopen
      const selections = this.appState.get('contentSurveySelections') ?? {};
      if (!selections[this.contentSurvey?.screenContentId]) {
        selections[this.contentSurvey?.screenContentId] = {};
      }
      selections[this.contentSurvey?.screenContentId][question.questionId] = option.optionId;
      this.appState.set('contentSurveySelections', selections);
      this.storeSurveyData(this.contentSurvey);
    }
  
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      translucent: true,
      header:'Interaction' ,
      message: msg,
    });
   
  
    await alert.present();
  }
  private isEnabled() {
    this.enabled = this.path.enabledAttributes['polls']
  }


  public isCorrectAnswer(option, question) {
    // mixpanel.track('isCorrectAnswer', {'question': question, 'option': option})
    if (option?.isSelected) {
      // if (!this.loading && option.isCorrect) {
        return true
      // }
    } else if (question?.userResponse) {
      if (question.userResponse.optionId === option.optionId) {
        return true
      }
    }
    return false
  }
  async presentPopover(ev) {
    const dynamicText = this.i18n.t('These charts show the breakdown of answers among all your colleagues in this cycle.');
    const popover = await this.popover.create({
      component: PopoverComponent,
      translucent: true,
      event: ev,
      mode:'ios',
      showBackdrop: true,
      cssClass: 'custom-popover',
      componentProps: {
        dynamicText: dynamicText,
      },
    });
    await popover.present();
    await popover.onDidDismiss();
  }
  public isFalseAnswer(option, question) {
    // mixpanel.track('isFalseAnswer', {'question': question, 'option': option})
    if (option.isSelected) {
      if (!this.loading && !option?.isCorrect) {
        return true
      }
    } else if (question.userResponse) {
      if (!question.userResponse?.isCorrect && question.userResponse?.optionId === option.optionId) {
        return true
      }
    }
    return false
  }

  public isNotAnswered(option, question) {
    if (!option.isSelected && question?.userResponse?.optionId !== option.optionId) {
      // mixpanel.track('isNotAnswered', {'question': question, 'option': option})
      return true
    }
    else {
      return false
    }
    //return question.answer && question.answer.optionId !== option.id
  }

  public isRightAnswer(option, question) {
    if (question.userResponse && question.userResponse.correctOptionId === option.optionId && !question.userResponse.isCorrect) {
      // mixpanel.track('isRightAnswer', {'question': question, 'option': option})
      return true
    }
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }
}
